import { useEffect, useState } from "react"
import { useParams } from "react-router-dom";
import { dataDecrypt, encrypt } from "../../../../../app/utility/encryption-helper";
import { ApisService } from "../../../../../app/core/apis.service";
import toast from "react-hot-toast";
import { IMAGE_PATH } from "../../../../../config";
import { Breadcrumb } from "../../../../../components/breadcum";
import { LookupService } from "../../../../../app/core/lookup.service";
import { FormatIndianDate } from "../../../../../app/utility/formatIndianDate";

export const OrderView = () => {
    const params = useParams();
    const [loading, setLoading] = useState<boolean>(false);
    const [orderData, setOrderData] = useState<any>([]);
    const [productIds, setProductIds] = useState<any>([]);

    useEffect(() => {
        orderedProducts({ id: params.id });
    }, [params.id]);
    async function orderedProducts(payload: any): Promise<void> {
        setLoading(true);
        try {
            const encryptedData = encrypt(JSON.stringify(payload));
            const res = await ApisService.getById("getById_v2", encryptedData);
            const transactionsData = JSON.parse(dataDecrypt(res.data.data));
            if (transactionsData?.length > 0) {
                setOrderData(transactionsData[0]);
            }
            setLoading(false);
        }
        catch (error) {
            setLoading(false);
            toast.error(`${error}`);
        }
    }

    const breadcrumbInfo = [
        {
            label: "ONDC Orders",
            value: "ONDC Orders",
            routerLink: `/dashboard/organizations/org-details/${params.org}/ondc-orders`,
            isActive: false,
        },
        {
            label: `Info`,
            value: `Info`,
            routerLink: ``,
            isActive: true,
        },
    ];

    const handleSelectProduct = (id: string) => {
        if (productIds.includes(id)) {
            setProductIds(productIds.filter((item: any) => item !== id));
        } else {
            // setProductIds([...productIds, id]);
            setProductIds([id]);
        }
    };

    const handleCancel = async () => {
        if (productIds.length === 0) {
            toast.error("Please select at least one product to cancel.");
        }
        else {
            let payload = {
                order_id: orderData?.ondc?.order?.id,
                reason_code: "002",
                products: productIds,
                order_state: "Accepted"
            }
            try {
                const res = await LookupService.cancelOrder(payload);
                if (res) {
                    toast.success("Order cancelled successfully.");
                    setProductIds([]);
                    orderedProducts({ id: params.id });
                }
            }
            catch (error: any) {
                toast.error(`Error: ${error}`);
            }
        }
    }

    return (
        <div className="container-fluid content-bg-color">
            <Breadcrumb breadCrumbList={breadcrumbInfo}></Breadcrumb>
            {loading ? (<div>Loading...</div>) : (<div>
                <div className="card">
                    <div className="card-body">
                        <div className="text-end">Created Date : {FormatIndianDate(orderData?.created_date, "")}</div>
                        <div className="card mb-2">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-4 mb-2">
                                        <div className="fw-bold">Buyer App</div>
                                        <div>{orderData?.ondc?.buyer_app}</div>
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <div className="fw-bold">Order Id</div>
                                        <div>{orderData?.ondc?.order?.id}</div>
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <div className="fw-bold">Order Status</div>
                                        {orderData?.invoice_details ? <div>{orderData?.invoice_details && orderData?.invoice_details[0]?.status.split(" ").map((item: any) => item.charAt(0).toUpperCase() + item.slice(1)).join(" ")}</div> : <div>{orderData?.order_details?.status}</div>}
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <div className="fw-bold">Buyer Name</div>
                                        <div>{orderData?.buyer?.name}</div>
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <div className="fw-bold">Seller Id</div>
                                        <div>{orderData?.seller?.id}</div>
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <div className="fw-bold">Invoice Amount</div>
                                        {orderData?.invoice_details ? <div>₹ {orderData?.invoice_details && orderData?.invoice_details[0]?.invoice_amount}</div> : <div>₹ {orderData?.order_details?.products?.reduce((sum: any, item: any) => sum + item.total, 0)}</div>}
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <div className="fw-bold">Seller Contact</div>
                                        <div>{orderData?.seller?.contact_number}</div>
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <div className="fw-bold">Buyer Contact</div>
                                        <div>{orderData?.buyer?.phone}</div>
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <div className="fw-bold">Buyer Address</div>
                                        <div>{orderData?.buyer?.address?.name}{orderData?.buyer?.address?.name && ','}</div>
                                        <div>{orderData?.buyer?.address?.building}{orderData?.buyer?.address?.building && ','}{orderData?.buyer?.address?.locality}{orderData?.buyer?.address?.locality && ','}{orderData?.buyer?.address?.city}{orderData?.buyer?.address?.city && ','}{orderData?.buyer?.address?.state}{orderData?.buyer?.address?.state && ','}{orderData?.buyer?.address?.country}{orderData?.buyer?.address?.country && ','}</div>
                                        <div>{orderData?.buyer?.address?.area_code}.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-body">
                                <h4 className="">Product List</h4>
                                {orderData && orderData?.order_details?.products.map((item: any, index: number) => (
                                    <div key={index} className="card mb-2 rounded border-secondary">
                                        <div className="card-body">
                                            <div className="row align-items-center fs-14">
                                                <div className="col-md-2"><div className="form-check"><input
                                                    className="form-check-input border border-secondary p-2 cursor-pointer"
                                                    type="checkbox"
                                                    value=""
                                                    id={`flexCheck-${item.id}`}
                                                    checked={productIds.includes(item.id)}
                                                    onChange={() => handleSelectProduct(item.id)}
                                                /></div><img src={`${IMAGE_PATH}/${item.product_image}`} alt={item.product_name} className="w-100-h-100" /></div>
                                                <div className="col-md-4 lh-2">{item.product_name}</div>
                                                <div className="col-md-4">quantity: {item.quantity}</div>
                                                <div className="col-md-2">Total: ₹{item.total}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className="text-center mt-4"><button className={`btn ${productIds.length === 0 ? "disabled-btn border-secondary" : "btn-danger"}`} onClick={() => handleCancel()}>Cancel</button></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>)}
        </div>
    )
}